import React from 'react';
import PropTypes from 'prop-types';
import './ContentPage.sass';

import {connect} from 'react-redux';

import {fetchPage} from '../../ducks/pages';
import {setAlternateResources} from '../../ducks/channels';
import {setBackground} from '../../ducks/ui';

import Meta from '../../components/meta/Meta';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Loader from '../../components/loader/Loader';
import ErrorPage from '../errorPage/ErrorPage';
import WysiwygHtml from '../../components/rawHtml/WysiwygHtml';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';

@connect(({pages}, {params}) => ({page: pages[params.splat]}))
export default class ContentPage extends React.PureComponent {
  static fetchData = ({dispatch, params}) => dispatch(fetchPage(params.splat))
    .then(page => dispatch(setAlternateResources(page.alternateSlugs, '/page')));

  componentDidMount() {
    const {dispatch, params, page} = this.props;

    dispatch(setBackground());

    if (page === undefined) {
      dispatch(fetchPage(params.splat));
    }

    if (page) {
      dispatch(setAlternateResources(page.alternateSlugs, '/page'))
    }
  }

  componentDidUpdate() {
    const {dispatch, params, page} = this.props;

    if (page === undefined) {
      dispatch(fetchPage(params.splat));
    }

    if (page) {
      dispatch(setAlternateResources(page.alternateSlugs, '/page'))
    }
  }

  render() {
    const {page} = this.props;

    if (page === false) {
      return <ErrorPage/>;
    }

    if (!page) {
      return <Loader page/>;
    }

    return (
      <React.Fragment>
        <Meta
          fallbackTitle={page.title}
          alternateSlug={page.alternateSlugs && page.alternateSlugs.default && ('page/' + page.alternateSlugs.default.slug)}
        />

        <JSONLDBoosthive />

        <div className="page-info">
          <Breadcrumbs links={[{name: page.title}]}/>

          <div className="text-block">
            <h1>{page.title}</h1>
          </div>

          <WysiwygHtml content={page.html}/>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/contentPage/ContentPage.js